import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fds-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() loadingType:string = 'table'; //table, detail, related, related-detail, fields
  @Input() columns:number = 1;
  @Input() rows: number = 1;
  @Input() line:number = 1;
  @Input() colHeight:string = '33px';

  lstColumns : any[] = [];
  lstRows : any[] = []; 

  loadingTheme:any = {
    tableColumn: {
      'height.px': 10,
      'border-radius': 0,
      'margin-bottom': 0,
      'background-color': '#d8d8d8'
    },
    inputField: {
      label: {
        'height.px' : 14,
        'width' : "25%",
        'margin-bottom': "5px",
        'background-color': '#d8d8d8'
      },
      value: {
        'height.px' : 36,
        'background-color': '#d8d8d8'
      }
    }
  };

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.columns; i++) {
      this.lstColumns.push(i);
    }
    for (let i = 0; i < this.rows; i++) {
      this.lstRows.push(i);
    }
  }

}
